import React, { useEffect, useState } from 'react';
import { FaPen } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import { getCuves, getPompes, getProduits, getLivraisons, getMouvementsStock, getStations,
         createCuve, updateCuve, createPompe, updatePompe, createProduit, updateProduit,
         createLivraison, createMouvementStock } from '../services/api';

const GLOBAL_ROLES = ['superadmin', 'admin_siege', 'comptable', 'financier', 'fiscaliste', 'auditeur'];
const CATEGORIES = ['carburant', 'lubrifiant', 'gaz', 'accessoire', 'service'];

const Inventaire: React.FC = () => {
  const { user } = useAuth();
  const [tab, setTab] = useState<'cuves' | 'pompes' | 'produits' | 'livraisons' | 'mouvements'>('cuves');
  const [cuves, setCuves] = useState<any[]>([]);
  const [pompes, setPompes] = useState<any[]>([]);
  const [produits, setProduits] = useState<any[]>([]);
  const [livraisons, setLivraisons] = useState<any[]>([]);
  const [mouvements, setMouvements] = useState<any[]>([]);
  const [stations, setStations] = useState<any[]>([]);
  const [stationId, setStationId] = useState('');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [editingItem, setEditingItem] = useState<any>(null);
  const [form, setForm] = useState<any>({});
  const [msg, setMsg] = useState('');
  const isGlobal = GLOBAL_ROLES.includes(user?.role || '');

  useEffect(() => {
    if (isGlobal) getStations().then(r => setStations(r.data)).catch(console.error);
    getProduits().then(r => setProduits(r.data)).catch(console.error);
  }, []);

  useEffect(() => { loadData(); }, [tab, stationId]);

  const loadData = async () => {
    setLoading(true);
    const params: any = {};
    if (stationId) params.station_id = stationId;
    try {
      if (tab === 'cuves') setCuves((await getCuves(params)).data);
      if (tab === 'pompes') setPompes((await getPompes(params)).data);
      if (tab === 'produits') setProduits((await getProduits()).data);
      if (tab === 'livraisons') setLivraisons((await getLivraisons(params)).data);
      if (tab === 'mouvements') setMouvements((await getMouvementsStock(params)).data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const pctLevel = (c: any) => Math.round((c.niveau_actuel / c.capacite_litres) * 100);
  const fmt = (n: number) => new Intl.NumberFormat('fr-FR').format(n);

  const openCreate = (type: string) => {
    setEditingItem(null);
    setModalType(type);
    if (type === 'cuve') setForm({ station_id: stationId || '', code: '', produit_id: '', capacite_litres: '', niveau_actuel: '0', seuil_alerte: '', seuil_commande: '' });
    if (type === 'pompe') setForm({ station_id: stationId || '', code: '', cuve_id: '', produit_id: '' });
    if (type === 'produit') setForm({ code: '', nom: '', categorie: 'carburant', unite: 'litre', prix_vente: '', prix_achat: '', tva_rate: '18' });
    if (type === 'livraison') setForm({ station_id: stationId || '', cuve_id: '', produit_id: '', date_livraison: new Date().toISOString().slice(0, 10), numero_bl: '', quantite_litres: '', prix_unitaire: '' });
    if (type === 'mouvement') setForm({ station_id: stationId || '', cuve_id: '', produit_id: '', type_mouvement: 'entree', quantite: '', motif: '' });
    setShowModal(true);
  };

  const openEdit = (type: string, item: any) => {
    setEditingItem(item);
    setModalType(type);
    if (type === 'cuve') setForm({ code: item.code, produit_id: item.produit_id, capacite_litres: item.capacite_litres, seuil_alerte: item.seuil_alerte, seuil_commande: item.seuil_commande, statut: item.statut });
    if (type === 'pompe') setForm({ code: item.code, cuve_id: item.cuve_id, produit_id: item.produit_id, statut: item.statut });
    if (type === 'produit') setForm({ code: item.code, nom: item.nom, categorie: item.categorie, unite: item.unite, prix_vente: item.prix_vente, prix_achat: item.prix_achat, tva_rate: item.tva_rate });
    setShowModal(true);
  };

  const handleSave = async () => {
    setMsg('');
    try {
      if (modalType === 'cuve') {
        if (editingItem) await updateCuve(editingItem.id, form);
        else await createCuve(form);
      } else if (modalType === 'pompe') {
        if (editingItem) await updatePompe(editingItem.id, form);
        else await createPompe(form);
      } else if (modalType === 'produit') {
        if (editingItem) await updateProduit(editingItem.id, form);
        else await createProduit(form);
      } else if (modalType === 'livraison') {
        await createLivraison(form);
      } else if (modalType === 'mouvement') {
        await createMouvementStock(form);
      }
      setShowModal(false);
      setMsg('Enregistre avec succes');
      loadData();
    } catch (err: any) { setMsg(err.response?.data?.error || 'Erreur'); }
  };

  const renderModal = () => {
    if (!showModal) return null;
    const title = editingItem ? `Modifier ${modalType}` : `${modalType === 'livraison' ? 'Nouvelle' : 'Nouveau'} ${modalType}`;
    return (
      <div className="modal-overlay" onClick={() => setShowModal(false)}>
        <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 550 }}>
          <div className="modal-header"><h3>{title}</h3><button className="modal-close" onClick={() => setShowModal(false)}>&times;</button></div>
          <div className="modal-body">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {(modalType === 'cuve' || modalType === 'pompe' || modalType === 'livraison' || modalType === 'mouvement') && !editingItem && isGlobal && (
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label>Station *</label>
                  <select value={form.station_id} onChange={e => setForm({...form, station_id: e.target.value})}>
                    <option value="">-- Choisir --</option>
                    {stations.map(s => <option key={s.id} value={s.id}>{s.nom}</option>)}
                  </select>
                </div>
              )}
              {modalType === 'cuve' && <>
                <div className="form-group"><label>Code *</label><input type="text" value={form.code} onChange={e => setForm({...form, code: e.target.value})} placeholder="CUVE-XXX" /></div>
                <div className="form-group"><label>Produit *</label><select value={form.produit_id} onChange={e => setForm({...form, produit_id: e.target.value})}><option value="">--</option>{produits.filter(p => p.categorie === 'carburant').map(p => <option key={p.id} value={p.id}>{p.nom}</option>)}</select></div>
                <div className="form-group"><label>Capacite (L) *</label><input type="number" value={form.capacite_litres} onChange={e => setForm({...form, capacite_litres: e.target.value})} /></div>
                {!editingItem && <div className="form-group"><label>Niveau actuel (L)</label><input type="number" value={form.niveau_actuel} onChange={e => setForm({...form, niveau_actuel: e.target.value})} /></div>}
                <div className="form-group"><label>Seuil alerte (L)</label><input type="number" value={form.seuil_alerte} onChange={e => setForm({...form, seuil_alerte: e.target.value})} /></div>
                <div className="form-group"><label>Seuil commande (L)</label><input type="number" value={form.seuil_commande} onChange={e => setForm({...form, seuil_commande: e.target.value})} /></div>
                {editingItem && <div className="form-group"><label>Statut</label><select value={form.statut} onChange={e => setForm({...form, statut: e.target.value})}><option value="active">Active</option><option value="maintenance">Maintenance</option><option value="hors_service">Hors service</option></select></div>}
              </>}
              {modalType === 'pompe' && <>
                <div className="form-group"><label>Code *</label><input type="text" value={form.code} onChange={e => setForm({...form, code: e.target.value})} placeholder="PMP-XXX" /></div>
                <div className="form-group"><label>Cuve *</label><select value={form.cuve_id} onChange={e => setForm({...form, cuve_id: e.target.value})}><option value="">--</option>{cuves.map(c => <option key={c.id} value={c.id}>{c.code} ({c.produit_nom})</option>)}</select></div>
                <div className="form-group"><label>Produit *</label><select value={form.produit_id} onChange={e => setForm({...form, produit_id: e.target.value})}><option value="">--</option>{produits.filter(p => p.categorie === 'carburant').map(p => <option key={p.id} value={p.id}>{p.nom}</option>)}</select></div>
                {editingItem && <div className="form-group"><label>Statut</label><select value={form.statut} onChange={e => setForm({...form, statut: e.target.value})}><option value="active">Active</option><option value="maintenance">Maintenance</option><option value="hors_service">Hors service</option></select></div>}
              </>}
              {modalType === 'produit' && <>
                <div className="form-group"><label>Code *</label><input type="text" value={form.code} onChange={e => setForm({...form, code: e.target.value})} /></div>
                <div className="form-group"><label>Nom *</label><input type="text" value={form.nom} onChange={e => setForm({...form, nom: e.target.value})} /></div>
                <div className="form-group"><label>Categorie</label><select value={form.categorie} onChange={e => setForm({...form, categorie: e.target.value})}>{CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}</select></div>
                <div className="form-group"><label>Unite</label><input type="text" value={form.unite} onChange={e => setForm({...form, unite: e.target.value})} /></div>
                <div className="form-group"><label>Prix vente (FCFA)</label><input type="number" value={form.prix_vente} onChange={e => setForm({...form, prix_vente: e.target.value})} /></div>
                <div className="form-group"><label>Prix achat (FCFA)</label><input type="number" value={form.prix_achat} onChange={e => setForm({...form, prix_achat: e.target.value})} /></div>
                <div className="form-group"><label>TVA (%)</label><input type="number" value={form.tva_rate} onChange={e => setForm({...form, tva_rate: e.target.value})} /></div>
              </>}
              {modalType === 'livraison' && <>
                <div className="form-group"><label>Date *</label><input type="date" value={form.date_livraison} onChange={e => setForm({...form, date_livraison: e.target.value})} /></div>
                <div className="form-group"><label>N BL</label><input type="text" value={form.numero_bl} onChange={e => setForm({...form, numero_bl: e.target.value})} /></div>
                <div className="form-group"><label>Cuve *</label><select value={form.cuve_id} onChange={e => { const c = cuves.find(c => c.id === Number(e.target.value)); setForm({...form, cuve_id: e.target.value, produit_id: c ? c.produit_id : ''}); }}><option value="">--</option>{cuves.filter(c => !stationId || String(c.station_id) === stationId).map(c => <option key={c.id} value={c.id}>{c.code} ({c.produit_nom})</option>)}</select></div>
                <div className="form-group"><label>Quantite (L) *</label><input type="number" value={form.quantite_litres} onChange={e => setForm({...form, quantite_litres: e.target.value})} /></div>
                <div className="form-group"><label>Prix unitaire</label><input type="number" value={form.prix_unitaire} onChange={e => setForm({...form, prix_unitaire: e.target.value})} /></div>
              </>}
              {modalType === 'mouvement' && <>
                <div className="form-group"><label>Type *</label><select value={form.type_mouvement} onChange={e => setForm({...form, type_mouvement: e.target.value})}><option value="entree">Entree</option><option value="sortie">Sortie</option><option value="ajustement">Ajustement</option><option value="perte">Perte</option></select></div>
                <div className="form-group"><label>Cuve</label><select value={form.cuve_id} onChange={e => { const c = cuves.find(c => c.id === Number(e.target.value)); setForm({...form, cuve_id: e.target.value, produit_id: c ? c.produit_id : form.produit_id}); }}><option value="">--</option>{cuves.filter(c => !stationId || String(c.station_id) === stationId).map(c => <option key={c.id} value={c.id}>{c.code}</option>)}</select></div>
                <div className="form-group"><label>Produit *</label><select value={form.produit_id} onChange={e => setForm({...form, produit_id: e.target.value})}><option value="">--</option>{produits.map(p => <option key={p.id} value={p.id}>{p.nom}</option>)}</select></div>
                <div className="form-group"><label>Quantite *</label><input type="number" value={form.quantite} onChange={e => setForm({...form, quantite: e.target.value})} /></div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}><label>Motif</label><input type="text" value={form.motif} onChange={e => setForm({...form, motif: e.target.value})} placeholder="Raison du mouvement" /></div>
              </>}
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
            <button className="btn btn-primary" onClick={handleSave}>Enregistrer</button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="page-header">
        <h2>Inventaire</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          {tab === 'cuves' && <button className="btn btn-primary" onClick={() => openCreate('cuve')}>+ Cuve</button>}
          {tab === 'pompes' && <button className="btn btn-primary" onClick={() => openCreate('pompe')}>+ Pompe</button>}
          {tab === 'produits' && <button className="btn btn-primary" onClick={() => openCreate('produit')}>+ Produit</button>}
          {tab === 'livraisons' && <button className="btn btn-primary" onClick={() => openCreate('livraison')}>+ Livraison</button>}
          {tab === 'mouvements' && <button className="btn btn-primary" onClick={() => openCreate('mouvement')}>+ Mouvement</button>}
        </div>
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}

      <div style={{ display: 'flex', gap: 0, marginBottom: 16, borderBottom: '2px solid #eee' }}>
        {['cuves', 'pompes', 'produits', 'livraisons', 'mouvements'].map(t => (
          <button key={t} onClick={() => setTab(t as any)}
            style={{ padding: '10px 20px', border: 'none', background: tab === t ? '#004A97' : 'transparent', color: tab === t ? '#fff' : '#666', cursor: 'pointer', fontWeight: tab === t ? 600 : 400, borderRadius: '6px 6px 0 0', fontSize: 13, textTransform: 'capitalize' }}>
            {t}
          </button>
        ))}
      </div>

      {isGlobal && tab !== 'produits' && (
        <div className="filters">
          <select value={stationId} onChange={e => setStationId(e.target.value)}>
            <option value="">Toutes les stations</option>
            {stations.map((s: any) => <option key={s.id} value={s.id}>{s.nom}</option>)}
          </select>
        </div>
      )}

      {loading ? <div className="loading">Chargement...</div> : (
        <>
          {tab === 'cuves' && (
            <div className="cards-grid">
              {cuves.map((c: any) => {
                const pct = pctLevel(c);
                const color = pct < 15 ? '#e53935' : pct < 30 ? '#ff9800' : '#4caf50';
                return (
                  <div key={c.id} className="card" style={{ cursor: 'pointer' }} onClick={() => openEdit('cuve', c)}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                      <strong>{c.code}</strong>
                      <span className="badge badge-info">{c.produit_nom}</span>
                    </div>
                    <div className="progress-bar"><div className="progress-fill" style={{ width: `${pct}%`, backgroundColor: color }}></div></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginTop: 4 }}>
                      <span>{c.niveau_actuel.toLocaleString()} L</span>
                      <span>{c.capacite_litres.toLocaleString()} L</span>
                    </div>
                    {pct <= c.seuil_alerte / c.capacite_litres * 100 && c.seuil_alerte > 0 && (
                      <div style={{ fontSize: 11, color: '#e53935', marginTop: 4, fontWeight: 600 }}>Seuil alerte atteint!</div>
                    )}
                    {isGlobal && <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{c.station_nom} - {pct}%</div>}
                  </div>
                );
              })}
              {cuves.length === 0 && <div style={{ padding: 30, textAlign: 'center', color: '#999' }}>Aucune cuve</div>}
            </div>
          )}

          {tab === 'pompes' && (
            <table className="table">
              <thead><tr><th>Code</th><th>Produit</th><th>Cuve</th>{isGlobal && <th>Station</th>}<th style={{ textAlign: 'right' }}>Dernier index</th><th>Statut</th><th>Action</th></tr></thead>
              <tbody>
                {pompes.map((p: any) => (
                  <tr key={p.id}>
                    <td><code>{p.code}</code></td>
                    <td>{p.produit_nom}</td>
                    <td>{p.cuve_code}</td>
                    {isGlobal && <td>{p.station_nom || '-'}</td>}
                    <td style={{ textAlign: 'right' }}>{Number(p.dernier_index).toLocaleString()}</td>
                    <td><span className={`badge badge-${p.statut === 'active' ? 'success' : 'warning'}`}>{p.statut}</span></td>
                    <td><button className="btn btn-sm btn-primary" onClick={() => openEdit('pompe', p)}><FaPen /></button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'produits' && (
            <table className="table">
              <thead><tr><th>Code</th><th>Nom</th><th>Categorie</th><th>Unite</th><th style={{ textAlign: 'right' }}>Prix vente</th><th style={{ textAlign: 'right' }}>Prix achat</th><th>TVA</th><th>Action</th></tr></thead>
              <tbody>
                {produits.map((p: any) => (
                  <tr key={p.id}>
                    <td><code>{p.code}</code></td>
                    <td><strong>{p.nom}</strong></td>
                    <td><span className="badge badge-info">{p.categorie}</span></td>
                    <td>{p.unite}</td>
                    <td style={{ textAlign: 'right' }}>{fmt(Number(p.prix_vente))}</td>
                    <td style={{ textAlign: 'right' }}>{fmt(Number(p.prix_achat))}</td>
                    <td>{p.tva_rate}%</td>
                    <td><button className="btn btn-sm btn-primary" onClick={() => openEdit('produit', p)}><FaPen /></button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'livraisons' && (
            <table className="table">
              <thead><tr><th>Date</th>{isGlobal && <th>Station</th>}<th>Produit</th><th>BL</th><th style={{ textAlign: 'right' }}>Quantite</th><th style={{ textAlign: 'right' }}>Montant</th></tr></thead>
              <tbody>
                {livraisons.map((l: any) => (
                  <tr key={l.id}>
                    <td>{new Date(l.date_livraison).toLocaleDateString('fr-FR')}</td>
                    {isGlobal && <td>{l.station_nom}</td>}
                    <td>{l.produit_nom}</td>
                    <td><code>{l.numero_bl}</code></td>
                    <td style={{ textAlign: 'right' }}>{l.quantite_litres.toLocaleString()} L</td>
                    <td style={{ textAlign: 'right' }}>{fmt(l.montant_total)} FCFA</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'mouvements' && (
            <table className="table">
              <thead><tr><th>Date</th>{isGlobal && <th>Station</th>}<th>Type</th><th>Produit</th><th>Cuve</th><th style={{ textAlign: 'right' }}>Quantite</th><th>Motif</th><th>Par</th></tr></thead>
              <tbody>
                {mouvements.map((m: any) => (
                  <tr key={m.id}>
                    <td>{new Date(m.date_mouvement).toLocaleDateString('fr-FR')}</td>
                    {isGlobal && <td>{m.station_nom}</td>}
                    <td><span className={`badge badge-${m.type_mouvement === 'entree' ? 'success' : m.type_mouvement === 'sortie' ? 'warning' : 'critical'}`}>{m.type_mouvement}</span></td>
                    <td>{m.produit_nom}</td>
                    <td>{m.cuve_code || '-'}</td>
                    <td style={{ textAlign: 'right' }}>{Number(m.quantite).toLocaleString()}</td>
                    <td>{m.motif || '-'}</td>
                    <td>{m.cree_par_prenom} {m.cree_par_nom}</td>
                  </tr>
                ))}
                {mouvements.length === 0 && <tr><td colSpan={isGlobal ? 8 : 7} style={{ textAlign: 'center', padding: 30 }}>Aucun mouvement</td></tr>}
              </tbody>
            </table>
          )}
        </>
      )}

      {renderModal()}
    </div>
  );
};

export default Inventaire;
